import { MessageEntity, IMessage } from "../entity/message";
import { MessageOutPutDataDTO } from "src/app/core/chat/repository/dto/messageOutputDTO";
import { MessageInputDTO } from "../usecase/message/message-create-use-case.service";
import { getInstanceId } from "src/app/module/chat/domain/chat-service.service";

export class MessageMapper {
  static toDomain(DTO: MessageOutPutDataDTO) : MessageEntity {
    return DTO as MessageEntity
  }

  static fromDomain(entity:IMessage, requestId): MessageInputDTO {
    return {
      receiverId: entity.receiverId,
      canEdit: entity.canEdit,
      message: entity.message,
      messageType: entity.messageType,
      oneShot: entity.oneShot,
      requireUnlock: entity.requireUnlock,
      roomId: entity.roomId,
      senderId: entity.sender.wxUserId,
      requestId: entity.requestId || requestId,
      attachment: entity.attachments.map((e)=>(e.id)) || [],
      deviceId: getInstanceId()
    }
  }
}
